// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsTestUserLogsSearchTermsResult = objectOf({
  app_data: arrayOf(
    objectOf({
      id: string,
      name: string,
      type: string,
    })
  ),
  test_users: arrayOf(
    objectOf({
      id: string,
      name: string,
    })
  ),
});
